module.exports = __webpack_public_path__ + "img/2025-12-20e_2.98fc9a98.jpg";